import { render } from "./ProductGroupReport.vue?vue&type=template&id=ad6672be&scoped=true"
import script from "./ProductGroupReport.vue?vue&type=script&lang=js"
export * from "./ProductGroupReport.vue?vue&type=script&lang=js"

import "./ProductGroupReport.vue?vue&type=style&index=0&id=ad6672be&lang=scss"
import "./ProductGroupReport.vue?vue&type=style&index=1&id=ad6672be&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad6672be"]])

export default __exports__